import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

const Image = ({ image, alt, className }) => {

  const gatsbyImg = getImage(image)
  return (
    <div className='w-full h-full'>{gatsbyImg ? <GatsbyImage image={gatsbyImg} className={className} alt={alt} /> : <img src={image?.src} srcSet={image?.srcSet} alt={alt} /> }</div>
  )
}

export default Image
